export async function getFitmentData(details) {
    const defaultArgs = {
        calltype: null,
        website: 'jrcoLocal',
        equipmentCategory: '',
        manufacturer: '',
        model: '',
        modelType: '',
        deckSize: '',
        unitConfiguration: '',
        bagger: '',
        year: ''
    }
    const resolvedArgs = {...defaultArgs, ...details}
    var formBody = [];
    for (var property in resolvedArgs) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(resolvedArgs[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    const response = await fetch(`${process.env.REACT_APP_COMMON_LIBRARIES_HANDLERS_ROOT}/pl3JrcoConfiguratorHandler.asp`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept': 'text/html, */*; q=0.01',
        },
        body: formBody,
    })
    if (response.ok) {
        const result = await response.text();
        const pattern = /value\s*=\s*"(?<value>.*)".*>(?<label>.*)</g 
        const details = Array.from(result.matchAll(pattern)).map(match => {
            return {
                label: match.groups.label.replace('&quot;', '"'),
                value: match.groups.value.replace('&quot;', '"'),
            }
        })
        if (details[0]?.label === 'Choose') {
            details.splice(0, 1);
        }
        return details;
    }
    
    console.error(`Error fetching data: ${response.status} ${response.statusText}`);
    return [];
}

export async function getProductDetails(requestDetails) {
    // var formBody = [];
    // for (var property in requestDetails) {
    //     var encodedKey = encodeURIComponent(property);
    //     var encodedValue = encodeURIComponent(requestDetails[property]);
    //     formBody.push(encodedKey + "=" + encodedValue);
    // }
    // formBody = formBody.join("&");
    const response = await fetch(`${process.env.REACT_APP_COMMON_LIBRARIES_HANDLERS_ROOT}/pl3JrcoConfigurator10.asp`, {
        method: 'POST',
        headers: {
            'Content-Type': 'text/plain; charset=UTF-8',
            'Accept': '*/*',
        },
        body: JSON.stringify({...requestDetails, website: 'jrcoLocal'}),
    })
    if (response.ok) {
        const result = await response.json();
        return result
    }
    
    console.error(`Error fetching data: ${response.status} ${response.statusText}`);
    return {}
}